import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import Skeleton from 'react-loading-skeleton';

interface SkeletonProps {
  children?: ReactNode;
  labelSize: number;
  className?: string;
}

export const VerticalFormGroupSkeleton: FC<SkeletonProps> = ({ labelSize, className }) => {
  return (
    <div className={classNames('form-group', className)}>
      <label className="col-form-label">
        <Skeleton width={labelSize + 'em'} />
      </label>
      <div className="d-block form-control" />
    </div>
  );
};

VerticalFormGroupSkeleton.displayName = 'VerticalFormGroupSkeleton';
